/**
 * Fremde Protokolleinträge nur lesen (11.10.2026): a teacher / substitute (Lehrkraft-Bereich, Bewerbungs-Bereich) may
 * read the protocol entries of others but change / delete only the own ones (author = own profile). Office logins and
 * other login types (partners …) stay as they are. Pure (checked in tests/timeline/logEntryEditRights.check.ts); the
 * backend decides (shrd rights-guard/logEntryEditRights.ts, recorder 403 FOREIGN_LOG_ENTRY_READ_ONLY), the frontend
 * only hides the buttons.
 */
import {PortalMode} from '@/helpers/portalMode';

export const FOREIGN_LOG_ENTRY_HINT = 'Diesen Eintrag hat jemand anderes geschrieben. Du kannst ihn nur lesen.';

const idOf = (value: unknown): string => {
    if (value === null || value === undefined) {
        return '';
    }
    const id = typeof value === 'object' ? (value as { _id?: unknown })._id : value;
    return id === null || id === undefined ? '' : String(id);
};

export function mayChangeForeignLogEntries(mode: PortalMode): boolean {
    return mode === 'office' || mode === 'none';
}

/** author (id or populated) is the logged in profile */
export function isOwnLogEntry(log: { author?: unknown } | null | undefined, profileId: unknown): boolean {
    const author = idOf(log?.author);
    return !!author && author === idOf(profileId);
}

export function mayChangeLogEntry(mode: PortalMode, log: { author?: unknown } | null | undefined, profileId: unknown): boolean {
    return mayChangeForeignLogEntries(mode) || isOwnLogEntry(log, profileId);
}
